import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import flexColumns from '../../utils/flexColumns';
import themeResponsiveProperty from "../responsive/themeResponsiveProperty";

export default styled(({ isSelected, replace = false, ...props }) => <Link {...props} replace={replace} />)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${themeResponsiveProperty(null, '0 1.5rem')};
  border-bottom: ${themeResponsiveProperty('1px solid rgba(0,0,0,.27)', '2px solid rgba(0,0,0,.27)')};
  color: #000;
  background-color: ${themeResponsiveProperty(null, ({ isSelected = false }) => isSelected ? '#ddd' : null)};
  transition: background-color ease 200ms;

  ${({ columns }) => flexColumns(columns)};

  > span {
    padding-top: .75rem;
    padding-bottom: .75rem;
  }

  &:last-child {
    border-bottom: none;
  }
`;
